import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import Spacing from "../Spacing";
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import Inputmask from 'inputmask';
import { can_visit, clearLocalStorageExcept, notify, validatePassword } from "../../helpers";
import { fetchAllSpeciality, onboardPracticev2 } from "../../services/users";
import { BriefcaseMedical, Check, ChevronLast, ChevronLeft, ChevronRight, CloudUpload, DatabaseBackup, Loader, Plus, Send, X } from "lucide-react";
import ConfirmationModal from "../Modal/ConfirmationModal";
import { Config } from "../../Config";
import { syncIcdCptData, syncPatientData } from "../../services/workerServices";
import { searchNewNPI } from "../../services/npiManagement";
import NpiField from "./NpiField";

export default function NewOnboardPractice() {
  const STEP = {
    PRACTICE: 1,
    LOCATION: 2,
    ADMIN: 3,
    FILE: 4,
  };

  const defaultLocationValues = [{
    name: "",
    website: "",
    google_map_place_id: "",
    npi_number: null,
    phone: "",
    address1: "",
    city: "",
    state: "",
    zipcode: "",
    specialities: []
  }];
  const adminInformations = {
    username: "",
    email: "",
    first_name: "",
    last_name: "",
    password: "",
    contact: ""
  };
  const defaultValues = {
    practice_name: "",
    alt_practice_name: "",
    email: "",
    available_credit: 2000,
    letter_credit: 500,
    medmo_api_key: "",
    appointment_slug: "",
    logo_link: "",
    appointment_notification_email: "",
    rejection_notification_email: "",
    emr_type: "",
    account_type: [],
    locations: [],
    admin_info: {}
  }
  const defaultFileValues = {
    account_id: null,
    location_id: null,
    file_format: ""
  };
  const npiSearchTimeoutRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [locations, setLocations] = useState(defaultLocationValues);
  const [adminInfo, setAdminInfo] = useState(adminInformations);
  const [formData, setFormData] = useState(defaultValues);
  const [fileData, setFileData] = useState(defaultFileValues);
  const [validSlug, setValidSlug] = useState("");
  const [allSpeciality, setAllSpeciality] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [previousScrollPosition, setPreviousScrollPosition] = useState(0);
  const [formResetKey, setFormResetKey] = useState(0);
  const [activeStep, setActiveStep] = useState(1);
  // const [activeStep, setActiveStep] = useState(STEP.PRACTICE);
  const [dataSyncMethod, setDataSyncMethod] = useState('');
  const [patientFiles, setPatientFiles] = useState([]);
  const [uploadPatientDisabled, setUploadPatientDisabled] = useState(true);
  const [filePatientError, setPatientFileError] = useState(false);
  const [uploadPatientLoader, setUploadPatientLoader] = useState(false);
  const [icdCptFiles, setIcdCptFiles] = useState([]);
  const [uploadIcdCptDisabled, setUploadIcdCptDisabled] = useState(true);
  const [fileIcdCptError, setIcdCptFileError] = useState(false);
  const [uploadIcdCptLoader, setUploadIcdCptLoader] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [requiredColumns, setRequiredColumns] = useState(null);
  const [newOnboardedLocationData, setNewOnboardedLocationData] = useState([]);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [practiceNpiStatus, setPracticeNpiStatus] = useState("idle");
  const [practiceNpiLoading, setPracticeNpiLoading] = useState(false);
  const [locationNpiStatus, setLocationNpiStatus] = useState({});
  const [locationNpiLoading, setLocationNpiLoading] = useState({});
  const MOBILE_BREAKPOINT = 700;

  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || "").trim());
  const isURL = (v) => { if (!v) return true; try { new URL(v); return true; } catch { return false; } };
  const isSlug = (v) => /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(String(v || "").trim());
  const digits = (v) => String(v || "").replace(/\D+/g, "");
  const isNPI = (v) => !v || digits(v).length === 10;
  const isPhone = (v) => !v || digits(v).length === 10;
  const isZip = (v) => !v || /^\d{5}(-\d{4})?$/.test(String(v).trim());

  const firstErrorFocus = (errs) => {
    const k = Object.keys(errs)[0];
    if (!k) return;
    const name = k.split(".").pop();
    const el = document.querySelector(`[name="${name}"]`);
    el?.focus?.();
  };

  const formatError = (err) => {
    if (!err) return null;
    if (typeof err === 'string') return err;
    if (Array.isArray(err)) {
      return err.map(e => (typeof e === 'object' ? (e.msg || JSON.stringify(e)) : e)).join(", ");
    }
    if (typeof err === 'object') return err.msg || err.message || JSON.stringify(err);
    return String(err);
  };

  useEffect(() => {
    setFileData((prevFileData) => ({
      ...prevFileData,
      file_format: formData.emr_type
    }));
  }, [formData]);

  const [emrType] = useState([
    { value: "ECW", label: "ECW" },
    { value: "MDLand", label: "MDLand" },
    { value: "VeradigmEHR", label: "VeradigmEHR" },
    { value: "AthenaHealth", label: "AthenaHealth" },
  ]);

  useEffect(() => {
    generatePassword();
    getAllSpeciality();
    setValidSlug("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getAllSpeciality = async () => {
    try {
      const response = await fetchAllSpeciality();
      if (response?.data) {
        const allSpecialities = response?.data?.map((option) => ({
          value: option?.id,
          label: option?.name,
        }))
        setAllSpeciality(allSpecialities);
      };
    } catch (error) {
      // console.log("🚀 ~ getAllSpeciality: ~ error:", error);
    }
  };

  const handleAccountTypeChange = (e) => {
    const { value, checked } = e.target;

    setFormData(prev => {
      let currentAccountTypes = Array.isArray(prev.account_type) ? prev.account_type : [];
      let updatedAccountTypes;
      if (checked) {
        updatedAccountTypes = [...currentAccountTypes, value];
      } else {
        updatedAccountTypes = currentAccountTypes.filter(type => type !== value);
      }

      return {
        ...prev,
        account_type: updatedAccountTypes
      };
    });
  };
  const handleNPISearch = async (index, npiNumber) => {
    if (!npiNumber || npiNumber.length !== 10) {
      notify("error", "Please enter 10-digit NPI number", 5);
      return;
    }
    const validNPI = isNPI(npiNumber);
    if (!validNPI) {
      notify("error", "Invalid NPI number format", 5);
      return;
    }

    if (index === 0) {
      setPracticeNpiLoading(true);
      setPracticeNpiStatus("idle");
    } else {
      setLocationNpiLoading(prev => ({ ...prev, [index]: true }));
      setLocationNpiStatus(prev => ({ ...prev, [index]: "idle" }));
    }

    setErrorMessage("");

    try {
      const result = await searchNewNPI({ npi_number: npiNumber });
      if (result?.data?.status === "success") {
        const npiInfo = result?.data?.npi_info || {};
        const newLocations = [...locations];
        newLocations[index] = {
          ...newLocations[index],
          name: npiInfo.organization_name || (npiInfo.first_name + " " + npiInfo.last_name).trim() || "",
          npi_number: npiNumber
        }
        setLocations(newLocations);
        if (index === 0) {
          setFormData(prev => ({
            ...prev,
            practice_name: npiInfo.organization_name || (npiInfo.first_name + " " + npiInfo.last_name).trim() || "",
            alt_practice_name: npiInfo.organization_name || (npiInfo.first_name + " " + npiInfo.last_name).trim() || ""
          }));
          setPracticeNpiStatus("valid");
        } else {
          setLocationNpiStatus(prev => ({ ...prev, [index]: "valid" }));
        }
        // notify("success", "NPI information fetched successfully", 5);
      } else {
        // notify("error", result?.data?.message || "No NPI found", 5);
        setErrorMessage("No NPI found");
        const newLocations = [...locations];
        newLocations[index].name = "";
        setLocations(newLocations);
        if (index === 0) {
          setFormData(prev => ({
            ...prev,
            practice_name: "",
            alt_practice_name: ""
          }));
          setPracticeNpiStatus("invalid");
        } else {
          setLocationNpiStatus(prev => ({ ...prev, [index]: "invalid" }));
        }
      }
    }
    catch (error) {
      console.error("NPI search error:", error);
      const errorMsg = error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Failed to fetch NPI information";
      notify("error", formatError(errorMsg), 5);
      setErrorMessage(errorMsg);
      if (index === 0) setPracticeNpiStatus("invalid");
      else setLocationNpiStatus(prev => ({ ...prev, [index]: "invalid" }));
    } finally {
      if (index === 0) setPracticeNpiLoading(false);
      else setLocationNpiLoading(prev => ({ ...prev, [index]: false }));
    }
  }

  const generatePassword = () => {
    const length = 12;
    const lower = "abcdefghijklmnopqrstuvwxyz";
    const upper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const numbers = "0123456789";
    const specials = "!@#$%^&*()_+~";
    const allChars = lower + upper + numbers + specials;

    let password = "";

    // ensure at least one of each:
    password += lower[Math.floor(Math.random() * lower.length)];
    password += upper[Math.floor(Math.random() * upper.length)];
    password += numbers[Math.floor(Math.random() * numbers.length)];
    password += specials[Math.floor(Math.random() * specials.length)];

    // fill the rest:
    for (let i = password.length; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * allChars.length);
      password += allChars[randomIndex];
    }

    // shuffle to mix required chars
    password = password
      .split("")
      .sort(() => 0.5 - Math.random())
      .join("");

    if (validatePassword(password)) {
      setAdminInfo(prev => ({ ...prev, password }));
    } else {
      generatePassword();
    }
  };

  const generateSlug = (text) => {
    return text
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-');
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "contact") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    if (name === "appointment_slug") {
      setValidSlug("");
      const lastChar = value.slice(-1);
      let formattedValue = value;
      if (lastChar === ' ') {
        formattedValue = value.slice(0, -1) + '-';
      }
      formattedValue = generateSlug(formattedValue);
      setFormData({
        ...formData,
        [name]: formattedValue,
      });
      return;
    }
    if (name === "email") {
      setFormData({
        ...formData,
        email: value.toLowerCase(),
        appointment_notification_email: value.toLowerCase(),
        rejection_notification_email: value.toLowerCase(),
      });
      return;
    }
    if (name === "npi_number") {
      if (value.length === 10) {
        if (npiSearchTimeoutRef.current) {
          clearTimeout(npiSearchTimeoutRef.current);
        }
        npiSearchTimeoutRef.current = setTimeout(() => {
          handleNPISearch(0, value);
        }, 500);
      } else {
        setPracticeNpiStatus("idle");
        if (npiSearchTimeoutRef.current) clearTimeout(npiSearchTimeoutRef.current);
        setFormData(prev => ({ ...prev, practice_name: "", alt_practice_name: "" }));
      }
    }
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleLocationChange = (index, e) => {
    const { name, value } = e.target;

    if (name === "phone") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }

    const newLocations = [...locations];
    newLocations[index][name] = value;

    if (name === "npi_number") {
      if (value.length === 10) {
        if (npiSearchTimeoutRef.current) {
          clearTimeout(npiSearchTimeoutRef.current);
        }
        npiSearchTimeoutRef.current = setTimeout(() => {
          handleNPISearch(index, value);
        }, 500);
      } else {
        setLocationNpiStatus(prev => ({ ...prev, [index]: "idle" }));
        if (npiSearchTimeoutRef.current) clearTimeout(npiSearchTimeoutRef.current);
        newLocations[index].name = "";
      }
    }
    setLocations(newLocations);
  };

  const addLocation = () => {
    setLocations([...locations, { name: "", website: "", google_map_place_id: "", npi_number: "", phone: "", address1: "", city: "", state: "", zipcode: "", specialities: [] }]);
  };

  const removeLocation = (index) => {
    if (locations.length > 1) {
      const newLocations = locations.filter((_, locIndex) => locIndex !== index);
      setLocations(newLocations);
    }
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      locations: locations
    }));
  }, [locations]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      admin_info: adminInfo
    }));
  }, [adminInfo]);

  const handleAdminInfoChange = (e) => {
    const { name, value } = e.target;
    let newValue = value;
    if (name === "username" || name === "email") {
      newValue = value.toLowerCase();
    }
    if (name === "contact") {
      const phoneInputs = document.querySelectorAll('.us_phone');
      Inputmask({
        mask: '(999) 999-9999',
        showMaskOnHover: false,
        showMaskOnFocus: true,
      }).mask(phoneInputs);
    }
    setAdminInfo({
      ...adminInfo,
      [name]: newValue
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    e.target.disabled = true;
    try {
      if (can_visit("new_practice_onboard")) {
        notify("info", "Do not close the window until the process has finished.", 10);
        const response = await onboardPracticev2(formData);

        if (response?.detail) {
          notify('error', response?.detail, 5);
        } else {
          if (response?.data?.status === 'success') {
            setSuccessMessage(response?.data?.message);
            setFileData((prevFileData) => ({
              ...prevFileData,
              account_id: response?.data?.practice_id
            }));
            const practiceLocationsOptions = response?.data?.location_list?.map((l) => ({ value: l?.id, label: l?.name }));
            setNewOnboardedLocationData(practiceLocationsOptions);
            setDataSyncMethod('patient');
            setActiveStep(4);
          } else {
            notify("error", response?.data?.message, 5);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", formatError(error?.response?.data?.detail), 5);
      }
    } finally {
      setLoading(false);
      e.target.disabled = false;
    }
  };

  const handleSpecialityChange = (index, selectedOption) => {
    const selectedValues = selectedOption ? selectedOption.map((option) => option.value) : [];

    const newLocations = [...locations];
    newLocations[index].specialities = selectedValues;
    setLocations(newLocations);
  };

  const handleSuccessModalClose = async (add_data = false) => {
    if (add_data) {
      await clearLocalStorageExcept();
      const rawString = `${adminInfo.username},${adminInfo.password}`;
      let login_url = `/login?auth=${btoa(rawString)}`;

      window.location.href = Config.appUrl + login_url;
    } else {
      setFormData({ ...defaultValues });
      setLocations(defaultLocationValues.map(l => ({ ...l })));
      setAdminInfo({ ...adminInformations });
      generatePassword();
      setValidSlug("");
      setShowSuccessModal(false);
      setFormResetKey(k => k + 1);
      setDataSyncMethod('');
      setPatientFiles([]);
      setIcdCptFiles([]);
      setActiveStep(1);
      window.scrollTo(0, previousScrollPosition);
    }
  };

  const validTypes = new Set([
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-excel",
    "text/csv",
    "application/csv",
  ]);

  const filterValidFiles = (fileList) => {
    const arr = Array.from(fileList || []);
    const invalid = arr.some((f) => !validTypes.has(f.type));
    return { files: invalid ? [] : arr, invalid };
  };

  //Patients: file changes & DnD
  const handlePatientFileChange = (e) => {
    const { files, invalid } = filterValidFiles(e.target.files);
    setPatientFileError(invalid || files.length === 0);
    setPatientFiles(files);
    setUploadPatientDisabled(!fileData.file_format || files.length === 0);
  };

  const handlePatientDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove("dragover");
    const { files, invalid } = filterValidFiles(e.dataTransfer.files);
    setPatientFileError(invalid || files.length === 0);
    setPatientFiles(files);
    setUploadPatientDisabled(!fileData.file_format || files.length === 0);
  };

  // ICD/CPT: file changes & DnD
  const handleICDCPTFileChange = (e) => {
    const { files, invalid } = filterValidFiles(e.target.files);

    setIcdCptFileError(invalid || files.length === 0);
    setIcdCptFiles(files);
    setUploadIcdCptDisabled(!fileData.file_format || files.length === 0);
  };

  const handleIcdDrop = (e) => {
    e.preventDefault();
    e.currentTarget.classList.remove("dragover");
    const { files, invalid } = filterValidFiles(e.dataTransfer.files);

    setIcdCptFileError(invalid || files.length === 0);
    setIcdCptFiles(files);
    setUploadIcdCptDisabled(!fileData.file_format || files.length === 0);
  };

  const fileListLabel = (filesArr) => {
    if (!filesArr?.length) return "";
    if (filesArr.length === 1) return filesArr[0].name;
    return filesArr.map((f) => f.name).join(", ");
  };

  const requiredColumnsList = (columns = []) => {
    if (!columns || columns.length === 0) return "";
    return columns.join(", ");
  };

  const handelSubmitPatientData = async (e) => {
    e.preventDefault();
    if (!patientFiles?.length) {
      notify("error", `Please upload an patient file(s)`, 5);
      return;
    }
    setUploadPatientDisabled(true);
    setUploadPatientLoader(true);
    setLoading(true);

    try {
      const total = patientFiles.length;
      for (let i = 0; i < total; i++) {
        const file = patientFiles[i];
        const updatedData = {
          ...fileData,
          file
        };
        setSelectedFileName(file?.name);
        const response = await syncPatientData(updatedData);

        if (response?.detail) {
          setErrorMessage(`❌ ${file?.name}: ${formatError(response?.detail)}`);
          notify("error", `❌ ${file?.name}: ${formatError(response?.detail)}`, 5);
          setUploadPatientDisabled(false);
        } else {
          if (response?.data?.status === 'success') {
            notify("success", `✅ ${file?.name}: ${response?.data?.message}`, 5);
            if (total === i + 1) {
              setPatientFiles([]);
              setUploadPatientDisabled(true);
              setErrorMessage(null);
              setRequiredColumns(null);
              setDataSyncMethod('icd');
            }
          } else {
            setErrorMessage(response?.data?.message);
            setRequiredColumns(response?.data?.required_columns || null);
            if (total !== i + 1) {
              notify("error", `❌ ${file?.name}: ${response?.data?.message}`, 5);
            }
            setUploadPatientDisabled(false);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        setErrorMessage(error?.response?.data?.detail);
        notify("error", formatError(error?.response?.data?.detail), 5);
      }
      setUploadPatientDisabled(false);
    } finally {
      setSelectedFileName('');
      setUploadPatientLoader(false);
      setLoading(false);
    }
  };

  const handelSubmitIcdCptData = async (e) => {
    e.preventDefault();
    if (!icdCptFiles?.length) {
      notify("error", "Please upload an ICD & CPT file(s)", 5);
      return;
    }
    setUploadIcdCptDisabled(true);
    setUploadIcdCptLoader(true);
    setLoading(true);

    try {
      const total = icdCptFiles.length;
      for (let i = 0; i < total; i++) {
        const file = icdCptFiles[i];
        const updatedData = {
          ...fileData,
          file
        };
        setSelectedFileName(file?.name);
        const response = await syncIcdCptData(updatedData);

        if (response?.detail) {
          setErrorMessage(`❌ ${file?.name}: ${formatError(response?.detail)}`);
          notify("error", `❌ ${file?.name}: ${formatError(response?.detail)}`, 5);
          setUploadIcdCptDisabled(false);
        } else {
          if (response?.data?.status === 'success') {
            notify("success", `✅ ${file?.name}: ${response?.data?.message}`, 5);
            if (total === i + 1) {
              setIcdCptFiles([]);
              setUploadIcdCptDisabled(true);
              setErrorMessage(null);
              setRequiredColumns(null);
              setShowSuccessModal(true);
              setPreviousScrollPosition(window.scrollY);
              window.scrollTo(0, 0);
            }
          } else {
            setErrorMessage(response?.data?.message);
            setRequiredColumns(response?.data?.required_columns || null);
            if (total !== i + 1) {
              notify("error", `❌ ${file?.name}: ${response?.data?.message}`, 5);
            }
            setUploadIcdCptDisabled(false);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        setErrorMessage(error?.response?.data?.detail);
        notify("error", formatError(error?.response?.data?.detail), 5);
      }
      setUploadIcdCptDisabled(false);
    } finally {
      setSelectedFileName('');
      setUploadIcdCptLoader(false);
      setLoading(false);
    }
  };

  const validateStep = (step) => {
    const e = {};

    if (step === STEP.PRACTICE) {
      if (practiceNpiStatus === "invalid" || !String(formData.npi_number || "").trim()) e["npi_number"] = "Please enter a valid NPI for next step.";
      else if (practiceNpiLoading) e["npi_number"] = "NPI search is in progress. Please wait.";
      else if (!String(formData.practice_name || "").trim()) e["practice_name"] = "Practice name is required.";

      if (!String(formData.email || "").trim()) e["email"] = "Practice email is required.";
      else if (!isEmail(formData.email)) e["email"] = "Enter a valid email.";
      if (formData.appointment_slug && !isSlug(formData.appointment_slug)) e["appointment_slug"] = "Slug can contain lowercase letters, numbers and dashes (no spaces).";
      if (formData.emr_type && !String(formData.emr_type || "").trim()) e["emr_type"] = "EMR type is required.";
    }

    if (step === STEP.LOCATION) {
      if (!locations?.length) e["locations"] = "Add at least one location.";
      locations?.forEach((loc, i) => {
        if (locationNpiStatus[i] === "invalid" || !String(loc?.npi_number || "").trim()) e[`locations.${i}.npi_number`] = `Please enter a valid NPI for Location ${i + 1} for next step.`;
        else if (locationNpiLoading[i]) e[`locations.${i}.npi_number`] = `NPI search in progress for Location ${i + 1}. Please wait.`;
        else if (!String(loc?.name || "").trim()) e[`locations.${i}.name`] = "Location name is required.";

        if (loc?.website && !isURL(loc.website)) e[`locations.${i}.website`] = "Invalid URL.";
        if (loc?.npi_number && !isNPI(loc?.npi_number)) e[`locations.${i}.npi_number`] = "NPI must be 10 digits.";
        if (!isPhone(loc?.phone)) e[`locations.${i}.phone`] = "Phone must be 10 digits (US).";
        if (!isZip(loc?.zipcode)) e[`locations.${i}.zipcode`] = "ZIP must be 5 or 9 digits.";
      });
    }

    if (Object.keys(e).length) {
      notify("error", Object.values(e)[0], 5);
      firstErrorFocus(e);
      return false;
    }
    return true;
  };

  const goNext = () => {
    if (!validateStep(activeStep)) {
      return;
    }
    setActiveStep((s) => Math.min(3, s + 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goBack = () => {
    setActiveStep((s) => Math.max(1, s - 1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const StepDot = ({ number, label }) => {
    const isActive = activeStep === number;
    const isDone = activeStep > number;

    const [showLabel, setShowLabel] = React.useState(
      typeof window !== "undefined" ? window.innerWidth > MOBILE_BREAKPOINT : true
    );
    React.useEffect(() => {
      const onResize = () => setShowLabel(window.innerWidth > MOBILE_BREAKPOINT);
      window.addEventListener("resize", onResize);
      return () => window.removeEventListener("resize", onResize);
    }, []);

    const circleStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      height: 28,
      width: 28,
      marginRight: 8,
      backgroundColor: isDone ? "var(--accent)" : (isActive ? "transparent" : "var(--bg_soft)"),
      border: isActive ? "2px solid var(--accent)" : "none",
      color: isDone ? "#fff" : (isActive ? "var(--accent)" : "var(--muted)"),
      fontWeight: 600,
    };

    const labelStyle = {
      color: isActive ? "var(--accent)" : "var(--muted)",
      fontWeight: 600,
    };

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={circleStyle}>{isDone ? <Check size={16} /> : number}</div>
        {showLabel && <span style={labelStyle}>{label}</span>}
      </div>
    );
  };

  const Stepper = () => {
    const lineStyle = {
      flex: 1,
      height: 1,
      margin: "0 16px",
      backgroundColor: "var(--border)",
    };

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <StepDot number={1} label="Practice Information" />
        <div style={lineStyle} />
        <StepDot number={2} label="Location Information" />
        <div style={lineStyle} />
        <StepDot number={3} label="Admin Credentials" />
        <div style={lineStyle} />
        <StepDot number={4} label="Data Sync" />
      </div>
    );
  };

  useDocumentTitle("Onboard Practice");

  return (
    <>
      <div className="docpro_page_heading_wrap">
        <h2 className="docpro_page_heading docpro_fs_24">
          Onboard Practice
        </h2>
      </div>

      {/* Stepper */}
      <Spacing lg="15" sm="25" />
      <div className="docpro_onboarding_container">
        <Stepper />
        <Spacing lg="25" sm="35" />

        <div className="docpro_card relative">
          <form key={formResetKey} onSubmit={activeStep === STEP.FILE ? (dataSyncMethod === "patient" ? handelSubmitPatientData : handelSubmitIcdCptData) : handleSubmit} autoComplete="off">
            {/* Step Titles */}
            {activeStep === STEP.PRACTICE && (
              <h6 className="docpro_fs_18 docpro_sky_color docpro_mb_0">Practice Information</h6>
            )}
            {activeStep === STEP.LOCATION && (
              <h6 className="docpro_fs_18 docpro_sky_color docpro_mb_0">Location Information</h6>
            )}
            {activeStep === STEP.ADMIN && (
              <h6 className="docpro_fs_18 docpro_sky_color docpro_mb_0">Admin Credentials</h6>
            )}
            {activeStep === STEP.FILE && (
              <>
                <div className="docpro_badge_green docpro_sync_data_badge new_practice">
                  <span className="icon">
                    <BriefcaseMedical width={24} height={24} />
                  </span>
                  <div>
                    <p className="mb-0"><span style={{ fontWeight: 600 }}>1.</span> First upload the patient data, then upload the ICD/CPT data.</p>
                    <p className="mb-0"><span style={{ fontWeight: 600 }}>2.</span> Any blank patient records will be uploaded to the location you select.</p>
                  </div>
                </div>
                <Spacing lg="20" sm="20" />
                <h6 className="docpro_fs_18 docpro_sky_color docpro_mb_0">
                  {dataSyncMethod === "patient" ? "Patient" : "ICD & CPT"} Data Sync{" "}
                  {formData?.practice_name && (
                    <>
                      For <span className="docpro_badge docpro_badge_default">{formData.practice_name}</span>
                    </>
                  )}
                </h6>
              </>
            )}

            <Spacing lg="20" sm="20" />

            {/* Steps Body */}
            {activeStep === STEP.PRACTICE && (
              <>
                <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                  <NpiField
                    label="NPI Number"
                    name="npi_number"
                    value={formData.npi_number}
                    onChange={handleChange}
                    status={practiceNpiStatus}
                    loading={practiceNpiLoading}
                    displayName={formData.practice_name}
                    required
                  />
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Contact Email <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="email"
                      className="docpro_form_field size_lg"
                      name="email"
                      required
                      onChange={handleChange}
                      defaultValue={formData.email}
                    />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Appointment Slug {"  "}
                      {validSlug === true ? (
                        <span className="docpro_badge docpro_badge_cyan docpro_square">Available</span>
                      ) : validSlug === false ? (
                        <span className="docpro_badge docpro_badge_red docpro_square">Not Available</span>
                      ) : (
                        ""
                      )}
                    </label>
                    <div className="docpro_form_field_with_icon_group">
                      <div className="docpro_form_field static_text">https://book.doc.pro/</div>
                      <input
                        type="text"
                        className="docpro_form_field slug size_lg"
                        name="appointment_slug"
                        placeholder="Slug"
                        onChange={handleChange}
                        defaultValue={formData.appointment_slug}
                        style={{ borderRadius: "0 8px 8px 0", paddingLeft: "8px" }}
                      />
                    </div>
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">EMR Type</label>
                    <Select
                      name="emr_type"
                      options={emrType}
                      onChange={(opt) => setFormData({ ...formData, emr_type: opt.value })}
                      placeholder="Search..."
                      isSearchable
                      value={emrType.find((o) => o.value === formData.emr_type)}
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base) => ({ ...base, minHeight: "40px", borderRadius: "8px", borderColor: "var(--border)" }),
                      }}
                    />
                  </div>
                </div>
                <Spacing lg="16" sm="22" />
                <div className="docpro_portal_use">
                  <label className="docpro_fw_500 docpro_primary_color">
                    Why do you want to use our portal?
                  </label>
                  <div className="docpro_radio_group">
                    <div className="docpro_checkbox">
                      <input
                        type="checkbox"
                        name="account_type"
                        onChange={handleAccountTypeChange}
                        checked={formData.account_type.includes("charting")}
                        value="charting"
                      />
                      <label style={{ paddingLeft: "30px" }}>AI Charting</label>
                    </div>
                    <div className="docpro_checkbox">
                      <input
                        type="checkbox"
                        name="account_type"
                        onChange={handleAccountTypeChange}
                        checked={formData.account_type.includes("portal")}
                        value="portal"
                      />
                      <label style={{ paddingLeft: "30px" }}>Portal</label>
                    </div>

                    <div className="docpro_checkbox">
                      <input
                        type="checkbox"
                        name="account_type"
                        onChange={handleAccountTypeChange}
                        checked={formData.account_type.includes("pre-visit")}
                        value="pre-visit"
                      />
                      <label style={{ paddingLeft: "30px" }}>Pre-visit</label>
                    </div>
                    <div className="docpro_checkbox">
                      <input
                        type="checkbox"
                        name="account_type"
                        onChange={handleAccountTypeChange}
                        checked={formData.account_type.includes("coding-suggestion")}
                        value="coding-suggestion"
                      />
                      <label style={{ paddingLeft: "30px" }}>Coding Suggestion</label>
                    </div>
                    <div className="docpro_checkbox">
                      <input
                        type="checkbox"
                        name="account_type"
                        onChange={handleAccountTypeChange}
                        checked={formData.account_type.includes("ai-billing")}
                        value="ai-billing"
                      />
                      <label style={{ paddingLeft: "30px" }}>AI Billing</label>
                    </div>
                  </div>
                </div>
                <Spacing lg="30" sm="50" />
                <Spacing lg="0" sm="50" />
              </>
            )}
            {activeStep === STEP.LOCATION && (
              <>
                {locations.map((location, index) => (
                  <div key={index} className="mb-4">
                    <div className="flex mb-2 pb-1">
                      {index === locations.length - 1 ? (
                        <div className="text-right">
                          <Spacing lg="10" sm="10" />
                          <button
                            type="button"
                            onClick={addLocation}
                            className="docpro_icon_btn docpro_fw_600 docpro_primary_color mr-2"
                            style={{ borderRadius: "50%", height: "30px", width: "30px" }}
                          >
                            <Plus width={20} height={20} />
                            <span className="docpro_tip">Add More Location</span>
                          </button>
                        </div>
                      ) : (
                        <div style={{ minWidth: "37px" }} />
                      )}
                      {locations.length > 1 && (
                        <div className="text-right">
                          <Spacing lg="10" sm="10" />
                          <button
                            type="button"
                            onClick={() => removeLocation(index)}
                            className="docpro_icon_btn docpro_red_color docpro_icon_btn_red mr-2"
                            style={{ borderRadius: "50%", height: "30px", width: "30px" }}
                          >
                            <X width={20} height={20} />
                            <span className="docpro_tip">Remove Location</span>
                          </button>
                        </div>
                      )}
                      <div className="w-full p-2 rounded-md docpro_locations" style={{ backgroundColor: index % 2 === 0 ? '#f8f8f8' : '' }}>
                        <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_3">
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">
                              Practice Location <span className="docpro_red_color">*</span>
                            </label>
                            <div style={{ position: "relative" }}>
                              <input
                                type="text"
                                className="docpro_form_field size_lg"
                                name="name"
                                value={location.name}
                                required
                                onChange={(e) => handleLocationChange(index, e)}
                                readOnly
                              />
                              {locationNpiLoading[index] && (
                                <span className="docpro_npi_loading_overlay">
                                  <Loader width={16} height={16} />
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">Website URL</label>
                            <input
                              type="url"
                              className="docpro_form_field size_lg"
                              name="website"
                              defaultValue={location?.website}
                              onChange={(e) => handleLocationChange(index, e)}
                              pattern="https?://.*"
                            />
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">Google Map Place ID</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg"
                              name="google_map_place_id"
                              defaultValue={location?.google_map_place_id}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <NpiField
                            label="NPI Number"
                            name="npi_number"
                            value={location?.npi_number}
                            onChange={(e) => handleLocationChange(index, e)}
                            status={locationNpiStatus[index]}
                            loading={locationNpiLoading[index]}
                            displayName={""}
                            required={false}
                          />
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">Phone</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg us_phone"
                              name="phone"
                              defaultValue={location?.phone}
                              maxLength={20}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">Address</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg"
                              name="address1"
                              defaultValue={location?.address1}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">City</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg"
                              name="city"
                              defaultValue={location?.city}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">State</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg"
                              name="state"
                              defaultValue={location?.state}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <div className="docpro_grid_item">
                            <label className="docpro_fw_500 docpro_primary_color">Zip Code</label>
                            <input
                              type="text"
                              className="docpro_form_field size_lg"
                              name="zipcode"
                              defaultValue={location?.zipcode}
                              onChange={(e) => handleLocationChange(index, e)}
                            />
                          </div>
                          <div className="docpro_grid_item" style={{ gridColumn: 'span 3' }}>
                            <label className="docpro_fw_500 docpro_primary_color">
                              Specialities
                            </label>
                            <Select
                              isMulti
                              name="specialities"
                              options={allSpeciality}
                              placeholder="Search..."
                              isSearchable
                              value={
                                allSpeciality?.filter((option) =>
                                  location.specialities?.includes(option.value)
                                ) || []
                              }
                              onChange={(selected) =>
                                handleSpecialityChange(index, selected)
                              }
                              className="react-select-container w-full"
                              classNamePrefix="react-select"
                              filterOption={(option, rawInput) => {
                                const words = rawInput.toLowerCase().split(" ");
                                return words.every((w) =>
                                  option.label.toLowerCase().includes(w)
                                );
                              }}
                              styles={{
                                control: (base) => ({
                                  ...base,
                                  minHeight: "40px",
                                  borderColor: "var(--border)",
                                  borderRadius: "8px",
                                }),
                                menu: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                  marginTop: "-2px",
                                  borderRadius: "0 0 3px 3px",
                                }),
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                  padding: 0,
                                }),
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                <Spacing lg="20" sm="20" />
              </>
            )}
            {activeStep === STEP.ADMIN && (
              <>
                <div className="docpro_grid docpro_grid_gap_20_16 docpro_grid_col_2">
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Username <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="text"
                      className="docpro_form_field size_lg"
                      name="username"
                      required
                      onChange={handleAdminInfoChange}
                      defaultValue={adminInfo.username}
                      minLength={6}
                    />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      First Name <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="text"
                      className="docpro_form_field size_lg"
                      name="first_name"
                      required
                      onChange={handleAdminInfoChange}
                      defaultValue={adminInfo.first_name}
                    />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Last Name <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="text"
                      className="docpro_form_field size_lg"
                      name="last_name"
                      required
                      onChange={handleAdminInfoChange}
                      defaultValue={adminInfo.last_name}
                    />
                  </div>
                  <div className="docpro_grid_item">
                    <label className="docpro_fw_500 docpro_primary_color">
                      Email <span className="docpro_red_color">*</span>
                    </label>
                    <input
                      type="email"
                      className="docpro_form_field size_lg"
                      name="email"
                      required
                      onChange={handleAdminInfoChange}
                      defaultValue={adminInfo.email}
                    />
                  </div>
                </div>
                <Spacing lg="30" sm="50" />
                <Spacing lg="0" sm="50" />
              </>
            )}
            {activeStep === STEP.FILE && (
              <>
                {!formData.emr_type && (
                  <>
                    <label className="docpro_fw_500 docpro_primary_color">
                      File Format
                    </label>
                    <Select
                      name="file_format"
                      options={emrType}
                      onChange={(selectedOption) => {
                        setFileData({ ...fileData, file_format: selectedOption.value });
                        setUploadPatientDisabled(false);
                      }}
                      placeholder="Search EMR..."
                      isSearchable={true}
                      value={emrType.find(
                        (option) => option.value === fileData.file_format
                      )}
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      styles={{
                        control: (base) => ({
                          ...base,
                          minHeight: '43px',
                          borderRadius: '8px',
                          borderColor: 'var(--border)',
                        }),
                      }}
                    />
                    <Spacing lg="20" sm="20" />
                  </>
                )}

                <label className="docpro_fw_500 docpro_primary_color">
                  Practice Location <span className="docpro_red_color">*</span>
                </label>
                <Select
                  name="location_id"
                  options={newOnboardedLocationData}
                  onChange={(selectedOption) => {
                    setFileData({ ...fileData, location_id: selectedOption.value });
                    setUploadPatientDisabled(false);
                  }}
                  placeholder="Search Location..."
                  isSearchable={true}
                  value={newOnboardedLocationData?.find(
                    (option) => option?.value === fileData?.location_id
                  )}
                  required
                  className="react-select-container w-full"
                  classNamePrefix="react-select"
                  styles={{
                    control: (base) => ({
                      ...base,
                      minHeight: '43px',
                      borderRadius: '8px',
                      borderColor: 'var(--border)',
                    }),
                  }}
                />
                <Spacing lg="20" sm="20" />

                {dataSyncMethod === "patient" ? (
                  <>
                    <label className="docpro_primary_color">
                      <span className="docpro_fw_500">Patient File(s)</span> <small className="docpro_red_color">(.xlsx, .xls, .csv)</small>
                    </label>
                    <div
                      className="docpro_input_file_container"
                      onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('dragover'); }}
                      onDragLeave={(e) => e.currentTarget.classList.remove('dragover')}
                      onDrop={handlePatientDrop}
                      role="button"
                      tabIndex={0}
                      aria-label="Upload Excel/CSV files by dragging or clicking"
                    >
                      <span className="docpro_file_icon" aria-hidden="true">
                        <CloudUpload height={28} width={28} />
                      </span>
                      <div className="docpro_file_text">
                        <div className="docpro_file_title">
                          {patientFiles.length ? fileListLabel(patientFiles) : "Drag and drop patient file(s)"}
                        </div>
                        <div className="docpro_file_hint">
                          {patientFiles.length ? '' : 'here, or click to upload'}
                        </div>
                      </div>

                      <input
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        className="docpro_file_hidden_input"
                        onChange={handlePatientFileChange}
                        multiple
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <label className="docpro_primary_color">
                      <span className="docpro_fw_500">ICD, CPT File(s)</span> <small className="docpro_red_color">(.xlsx, .xls, .csv)</small>
                    </label>
                    <div
                      className="docpro_input_file_container"
                      onDragOver={(e) => { e.preventDefault(); e.currentTarget.classList.add('dragover'); }}
                      onDragLeave={(e) => e.currentTarget.classList.remove('dragover')}
                      onDrop={handleIcdDrop}
                      role="button"
                      tabIndex={0}
                      aria-label="Upload Excel/CSV files by dragging or clicking"
                    >
                      <span className="docpro_file_icon" aria-hidden="true">
                        <CloudUpload height={28} width={28} />
                      </span>
                      <div className="docpro_file_text">
                        <div className="docpro_file_title">
                          {icdCptFiles.length ? fileListLabel(icdCptFiles) : 'Drag and drop ICD, CPT file(s)'}
                        </div>
                        <div className="docpro_file_hint">
                          {icdCptFiles.length ? '' : 'here, or click to upload'}
                        </div>
                      </div>

                      <input
                        type="file"
                        accept=".xlsx,.xls,.csv"
                        className="docpro_file_hidden_input"
                        onChange={handleICDCPTFileChange}
                        multiple
                      />
                    </div>
                  </>
                )}
                {(filePatientError || fileIcdCptError) && (
                  <p className="docpro_error_message docpro_mb_0">Please upload a valid Excel/CSV file(s).</p>
                )}
                {errorMessage && (
                  <p className="docpro_error_message docpro_mb_0">{formatError(errorMessage)}</p>
                )}
                {(requiredColumns && requiredColumns?.length > 0) && (
                  <p className="docpro_error_message docpro_mb_0 mt-1">Required Columns: {requiredColumnsList(requiredColumns)}</p>
                )}
                <Spacing lg="30" sm="50" />
              </>
            )}

            {/* Navigation Buttons */}
            <div className="flex items-center justify-between">
              <div>
                {activeStep === STEP.FILE ? (
                  <button
                    type="button"
                    onClick={() => {
                      setShowSuccessModal(true);
                      setPreviousScrollPosition(window.scrollY);
                      window.scrollTo(0, 0);
                    }}
                    className={`docpro_bordered_btn size_lg`}
                    style={{ borderColor: 'var(--red)' }}
                  >
                    <ChevronLast height={24} width={24} style={{ marginLeft: '-6px' }} />
                    Skip
                  </button>
                ) : (
                  <button
                    type="button"
                    onClick={activeStep !== STEP.FILE ? goBack : null}
                    disabled={activeStep === STEP.PRACTICE || activeStep === STEP.FILE}
                    className={`docpro_bordered_btn size_lg ${activeStep === STEP.PRACTICE || activeStep === STEP.FILE ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                  >
                    <ChevronLeft height={24} width={24} style={{ marginLeft: '-6px' }} />
                    Back
                  </button>
                )}
              </div>

              <div className="flex items-center gap-2">
                {activeStep === STEP.FILE ? (
                  <button
                    type="submit"
                    className="docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg"
                    disabled={dataSyncMethod === "patient" ? uploadPatientDisabled : uploadIcdCptDisabled}
                  >
                    <DatabaseBackup width={20} height={24} />
                    <span>Sync {dataSyncMethod === "patient" ? 'Patient' : 'ICD & CPT'}</span>
                    {dataSyncMethod === "patient" ? uploadPatientLoader : uploadIcdCptLoader && (
                      <span className="docpro_loading">
                        <Loader width={20} height={20} />
                      </span>
                    )}
                  </button>
                ) : (
                  <>
                    {activeStep !== STEP.ADMIN && (
                      <button
                        type="button"
                        onClick={goNext}
                        className="docpro_bordered_btn docpro_fw_600 size_lg"
                      >
                        Next
                        <ChevronRight height={24} width={24} style={{ marginRight: '-6px' }} />
                      </button>
                    )}

                    {activeStep === STEP.ADMIN && (
                      <button
                        type="submit"
                        className={`docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                        style={{ pointerEvents: `${loading ? "none" : "initial"}` }}
                      >
                        <Send height={24} width={20} />
                        Save
                        {loading && (
                          <span className="docpro_loading">
                            <Loader width={20} height={20} />
                          </span>
                        )}
                      </button>
                    )}
                  </>
                )}
              </div>
            </div>
          </form>

          {loading && (
            <div className="absolute top-0 left-0 w-full" style={{ height: '100%', zIndex: 3 }}>
              <div className="flex items-center loading" style={{ width: '100%', height: '100%', justifyContent: 'center', background: 'rgb(255 255 255 / 83%)', borderRadius: '12px' }}>
                <span className="docpro_loading" style={{ position: 'inherit', flexDirection: 'column', gap: '10px' }}>
                  <Loader width={46} height={46} style={{ color: 'var(--accent)' }} />
                  {selectedFileName && (
                    <p className="docpro_fs_18 docpro_fw_600 text-center">Processing... <br /><span className="docpro_fs_16 docpro_green_color">{selectedFileName}</span></p>
                  )}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>

      {showSuccessModal && (
        <ConfirmationModal
          actionType={handleSuccessModalClose}
          openModal={showSuccessModal}
          setOpenModal={setShowSuccessModal}
          name={successMessage}
          type={'onboarding_success'}
          previousScrollPosition={previousScrollPosition}
          userInformation={adminInfo}
          practiceInformation={formData}
        />
      )}
    </>
  );
}
